import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: any[] = [
        {
            label: 'Anagrafica',
            icon: 'pi pi-home',
            items: [
                {
                    label: 'Clienti & Fornitori',
                    icon: 'pi pi-fw pi-user',
                    routerLink: ['/anagrafica']
                },
                {
                    label: 'Deviatoi',
                    icon: 'pi pi-fw pi-book',
                    routerLink: ['/anagrafica-deviatoi']
                }
            ]
        },
        { separator: true },
        {
            label: 'Menu Deviatoi',
            items: [
                {
                    label: 'Misurazioni',
                    icon: 'pi pi-fw pi-pencil',
                    routerLink: ['/misurazioni']
                },
                {
                    label: 'Tolleranze L94',
                    icon: 'pi pi-fw pi-file',
                    routerLink: ['/scheda-l94']
                },
                {
                    label: 'Scheda Interventi',
                    icon: 'pi pi-fw pi-align-justify',
                    routerLink: ['/scheda-interventi']
                },
                // {
                //     label: 'Storico',
                //     icon: 'pi pi-fw pi-history',
                //     routerLink: ['/storico']
                // }
                // {
                //     label: 'Interfaccia GIS',
                //     icon: 'pi pi-fw pi-exclamation-circle',
                //     routerLink: ['/interfaccia-gis']
                // }
            ]
        }
    ];
}
